import { takeLatest } from 'redux-saga/effects';
import {
  getClientReferralListSuccess, getClientReferralListFail,
  getClientReferralDetailsSuccess, getClientReferralDetailsFail
} from './clientReferralState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/client-referrals');
const redirectData = { route:'/console/client-referrals', mode:'list', recordId:0 };
const modelName = 'Client Referral';
const modelId = 'crf_id';

function* getClientReferralList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getClientReferralListSuccess,
    getClientReferralListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getClientReferralDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getClientReferralDetailsSuccess,
    getClientReferralDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doClientReferralCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getClientReferralDetailsSuccess,
    getClientReferralDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

  function* doClientReferralUpdate(data) {
    const reloadActions = [
      "update_status",
    ];

    const redirect =
      reloadActions.includes(data.payload.action)
        ? { ...redirectData, mode: "reload" }
        : redirectData;

    yield doCrudCall(
      () =>
        crudService.doUpdate(
          data.payload.crf_id,
          data.payload
        ),
      getClientReferralDetailsSuccess,
      getClientReferralDetailsFail,
      updateRecordSuccess(modelName),
      redirect,
      UPDATING_MSG
    );
  }

function* doClientReferralDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getClientReferralDetailsSuccess,
    getClientReferralDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* clientReferralSaga() {
  yield takeLatest('clientReferral/getClientReferralList', getClientReferralList);
  yield takeLatest('clientReferral/getClientReferralDetails', getClientReferralDetails);
  yield takeLatest('clientReferral/doClientReferralCreate', doClientReferralCreate);
  yield takeLatest('clientReferral/doClientReferralUpdate', doClientReferralUpdate);
  yield takeLatest('clientReferral/doClientReferralDelete', doClientReferralDelete);
}

export default clientReferralSaga;
